<script setup>
import { inject, computed } from 'vue'

const pollParams = inject('pollParams')

const headerStyle = computed(() => ({
  '--title-length': pollParams?.title?.length ?? 10,
  ...(pollParams.value?.image ? { backgroundImage: `url(${pollParams.value.image})` } : {}),
}))
</script>

<template>
  <div class="poll-layout">
    <div class="poll-layout__header" :style="headerStyle">
      <h1 class="poll-layout__title">{{ pollParams.title }}</h1>
    </div>

    <div class="poll-layout__content">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.poll-layout {
  container-type: inline-size;
}

.poll-layout__header {
  background-color: var(--primary-color);
  background-size: cover;
  background-position: center;
  padding: 0.75rem 1.5rem;
  min-height: 5rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.poll-layout__title {
  font-size: clamp(1.4rem, calc(var(--title-length) * -0.025rem + 2.25rem), 2rem);
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  line-height: 1.1;
  color: var(--header-title-color, white);
  margin: 0;
  position: relative;
  z-index: 1;
}

.poll-layout__content {
  text-align: center;
  padding: 0 5cqw;
}
</style>
